import React, { useState, useContext } from 'react';
import './TagsCell.scss';
import { Chip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { I18nReactContext } from '../../../../../contexts/I18nContext';
import { TagsEditModal } from './TagsEditModal';

export const TagsCell = ({ fileId, tags = [], onTagsUpdated, companyId }) => {
    const { i18n } = useContext(I18nReactContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Log the props received by TagsCell
    console.log('TagsCell - props:', { fileId, companyId, tagsCount: tags?.length });

    // Determine how many tags to show (max 1)
    const visibleTags = tags.slice(0, 1);
    const hiddenTagsCount = Math.max(0, tags.length - 1);

    const handleEditClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="TagsCell">
                <div className="TagsCell__tags">
                    {tags && tags.length > 0 ? (
                        <>
                            {visibleTags.map((tag, index) => (
                                <Chip 
                                    key={index} 
                                    label={tag} 
                                    size="small" 
                                    className="TagsCell__tag"
                                />
                            ))}
                            {hiddenTagsCount > 0 && (
                                <span className="TagsCell__moreIndicator">
                                    {i18n.translate('superAdmin.assets.tags.andMoreTags', { context: { count: hiddenTagsCount } })}
                                </span>
                            )}
                        </>
                    ) : (
                        <span className="TagsCell__empty">{i18n.translate('superAdmin.assets.tags.noTags')}</span>
                    )}
                </div>
                <IconButton 
                    size="small" 
                    onClick={handleEditClick} 
                    className="TagsCell__editButton"
                >
                    <EditIcon fontSize="small" />
                </IconButton>
            </div>

            <TagsEditModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                fileId={fileId}
                tags={tags}
                onTagsUpdated={onTagsUpdated}
                companyId={companyId}
            />
        </>
    );
};
